module.exports = __webpack_public_path__ + "img/EmmaWilliams.21036b04.jpg";